import { render, staticRenderFns } from "./DxSelectSupervisorGrouped.vue?vue&type=template&id=fc564370&"
import script from "./DxSelectSupervisorGrouped.vue?vue&type=script&lang=js&"
export * from "./DxSelectSupervisorGrouped.vue?vue&type=script&lang=js&"
import style0 from "./DxSelectSupervisorGrouped.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports